import car from './assets/purple/tab_car.svg';
import dolar from './assets/purple/tab_dolar.svg';
import settings from './assets/purple/tab_settings.svg';
import signal from './assets/purple/tab_signal.svg';
import health from './assets/purple/tab_health.svg';

export const purpleData = [car, health, settings, signal, dolar];
